"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStepAvatarBackgroundColor = void 0;
var _js = _interopRequireDefault(require("@quintoandar/cozy-theme/tokens/js"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var getStepAvatarBackgroundColor = exports.getStepAvatarBackgroundColor = function getStepAvatarBackgroundColor(_ref) {
  var active = _ref.active,
    completed = _ref.completed;
  if (completed) {
    return _js["default"].alias.color.surface.positive["default"];
  }
  if (active) {
    return _js["default"].alias.color.surface.brand.highlight;
  }
  return _js["default"].alias.color.surface.highlight["default"];
};